import baseEnvironment from './base';

export const environment = baseEnvironment;
